import assets from './asset.js';
import shows from './shows.js';
import streaming from './streaming.js';

function v1(backendAxiosInstance) {
  return {
    ...assets(backendAxiosInstance),
    ...shows(backendAxiosInstance),
    ...streaming(backendAxiosInstance)
  };
}

export { v1 as default };
//# sourceMappingURL=index.js.map
